export var transformToSEOLinks = function transformToSEOLinks(navData) {
  try {
    var links = [];
    var uniqueURLs = new Set();
    var addIfNotExists = function addIfNotExists(link) {
      if (!uniqueURLs.has(link.url)) {
        uniqueURLs.add(link.url);
        links.push({
          title: link.title,
          url: link.url
        });
      }
    };
    navData.l1_navigation.forEach(function (level1) {
      level1.l1_navigation_link.forEach(addIfNotExists);
      level1.l2_navigation.forEach(function (level2) {
        level2.l2_navigation_link.forEach(addIfNotExists);
        level2.l3_navigation.forEach(function (level3) {
          level3.l3_navigation_link.forEach(addIfNotExists);
        });
      });
    });
    return links;
  } catch (error) {
    return [];
  }
};